import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import RegisterUser from './RegisterUser';
import { ClientsFetchAPI } from '../../api/Clients';
import LoadingAlert from '../Alerts/LoadingAlert';
import ErrorAlert from '../Alerts/ErrorAlert';
import { TablesFetchAPI } from '../../api/Tables';
import EditUserInfo from './EditUserInfo';
import initData from '../Home/initData';
import validDomain from '../../utils/validDomain';
import Select from 'react-select';
import Auth from './Auth';

/* ─────────────────────────────────────────────────────────
   CSS — inyectado una vez. Prefijo: .lu-
───────────────────────────────────────────────────────── */
const LU_CSS = `

`;

/* ── ICONS ── */
const IcoUser  = ()=><svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/><circle cx="12" cy="7" r="4"/></svg>;
const IcoLock  = ()=><svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><rect x="3" y="11" width="18" height="11" rx="2"/><path d="M7 11V7a5 5 0 0 1 10 0v4"/></svg>;
const IcoEyeOn = ()=><svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/><circle cx="12" cy="12" r="3"/></svg>;
const IcoEyeOff= ()=><svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24"/><line x1="1" y1="1" x2="23" y2="23"/></svg>;
const IcoBack  = ()=><svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2"><polyline points="15 18 9 12 15 6"/></svg>;
const IcoCheck = ()=><svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="3"><polyline points="20 6 9 17 4 12"/></svg>;

/* ═══════════════════════════════════════════════════════════
   COMPONENT — lógica 100% original, nuevo shell visual
═══════════════════════════════════════════════════════════ */
const LoginUser = ({ modalUser, setModalUser, shoppingCart, closedModalLoginAndRegister }) => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  /* inject CSS once */
  useEffect(() => {
    const id = "lu-styles";
    if (!document.getElementById(id)) {
      const el = document.createElement("style");
      el.id = id; el.textContent = LU_CSS;
      document.head.appendChild(el);
    }
  }, []);

  /* ════════════════════════════════════════════════════════
     LÓGICA ORIGINAL — 100% INTACTA
  ════════════════════════════════════════════════════════ */
  const [modalUserRegister, setModalUserRegister] = useState(false);
  const [nickNamel, setNickName] = useState('');
  const [password, setPassword] = useState('');
  const [selectTable, setSelectTable] = useState({});
  const [tables, setTables] = useState([]);
  const [showModalForgotPassword, setShowModalForgotPassword] = useState(false);

  const [guestClient, setGuestClient] = useState(() => {
    if (localStorage.getItem('guestClient') != null && localStorage.getItem('guestClient') != undefined && localStorage.getItem('guestClient') != '')
      return localStorage.getItem('guestClient');
    return null;
  });

  const cleanInputs = () => {
    setNickName('');
    setPassword('');
    setModalUser(false);
  };

  const loginUser = async (user, pass) => {
    LoadingAlert(t('profile.login.loggingIn'));
    let token = undefined;
    let business = JSON.parse(localStorage.getItem('business'));
    let data = {
      "nickname": nickNamel,
      "pass": password,
      "business_id": business.id,
    };
    if (user !== undefined && pass !== undefined) {
      data.nickname = user;
      data.pass = pass;
    }
    try {
      const response = await ClientsFetchAPI.loginClientForBusiness(data, token);
      ErrorAlert('', t('profile.login.loginSuccess'), 'success');
      let client = response.data.client;
      localStorage.setItem('client', JSON.stringify(client));
      localStorage.setItem('guestClient', 0);
      cleanInputs();
      updatePage();
    } catch (err) {
      ErrorAlert('', err.response.data.error, 'error');
      console.log(err);
    }
  };

  const updatePage = () => { window.location.reload(); };

  const handleSaveTableSelect = (option) => { setSelectTable(option.value); };

  const getTablesByBusiness = async (businessinfo_id, token) => {
    try {
      const response = await TablesFetchAPI.getBusinessTables(businessinfo_id, token);
      let tablesInfo = [];
      response.data.tables.forEach(table => {
        if (table.status === 1) { tablesInfo.push({ value: table, label: table.name }); }
      });
      setTables(tablesInfo);
    } catch (err) { console.log(err); }
  };

  useEffect(() => {
    if (localStorage.getItem('business') !== "" || localStorage.getItem('business') !== undefined || localStorage.getItem('business') !== null) {
      // getTablesByBusiness(JSON.parse(localStorage.getItem('business')).id, undefined)
    }
    if (guestClient !== 0 && guestClient !== null) {
      if (shoppingCart !== true) {
        // ErrorAlert('', 'Estás como invitado 😊 Inicia sesión o regístrate para una mejor experiencia.', 'info', 8000)
      }
    }
    if (shoppingCart == true) { setModalUserRegister(true); }
  }, [guestClient]);

  const [showPassword, setShowPassword] = useState('');
  const toogglePasword = () => { setShowPassword(!showPassword); };

  return (
    <>
      <div className="lu-root">
        <div className="lu-card">

          {/* ── HEADER ── */}
          <p className="lu-eyebrow">{t('profile.login.eyebrow')}</p>
          <h1 className="lu-title">{t('profile.login.title')}</h1>
          <p className="lu-subtitle">
            {t('profile.login.subtitle')}
          </p>

          {/* ── FIELDS ── */}
          <div className="lu-fields">

            {/* usuario */}
            <div className="lu-field">
              <label className="lu-label">{t('profile.login.usernameLabel')}</label>
              <div className="lu-input-wrap">
                <span className="lu-input-icon"><IcoUser /></span>
                <input
                  className="lu-input"
                  type="text"
                  id="text"
                  name="name"
                  placeholder={t('profile.login.usernamePlaceholder')}
                  required
                  spellCheck="false"
                  onChange={e => setNickName(e.target.value)}
                />
              </div>
            </div>

            {/* contraseña */}
            <div className="lu-field">
              <label className="lu-label">
                {t('profile.shared.passwordLabel')}
                <button className="lu-label-link" type="button" onClick={() => setShowModalForgotPassword(true)}>
                  {t('profile.login.forgotPassword')}
                </button>
              </label>
              <div className="lu-input-wrap">
                <span className="lu-input-icon"><IcoLock /></span>
                <input
                  className="lu-input"
                  type={showPassword ? 'text' : 'password'}
                  id="password"
                  name="pass"
                  placeholder={t('profile.login.passwordPlaceholder')}
                  required
                  spellCheck="false"
                  onChange={e => setPassword(e.target.value)}
                />
                <button className="lu-eye" type="button" onClick={toogglePasword} tabIndex={-1}>
                  {showPassword ? <IcoEyeOff /> : <IcoEyeOn />}
                </button>
              </div>
            </div>

            {/* mostrar contraseña — lógica original con toogglePasword */}
            <label className="lu-check-wrap">
              <input
                className="lu-check-input"
                type="checkbox"
                value="remember-me"
                id="flexCheckDefault"
                onChange={toogglePasword}
              />
              <span className="lu-check-box"><IcoCheck /></span>
              <span className="lu-check-label">{t('profile.shared.showPassword')}</span>
            </label>

          </div>

          {/* ── SUBMIT ── */}
          <button className="lu-btn-primary" type="button" onClick={() => loginUser()}>
            {t('profile.login.submit')}
          </button>

          {/* ── FILA INFERIOR: volver (si shoppingCart) ── */}
          {shoppingCart === true && (
            <div className="lu-row">
              <button className="lu-btn-ghost" type="button" onClick={() => closedModalLoginAndRegister()}>
                <IcoBack /> {t('profile.login.back')}
              </button>
            </div>
          )}

          {/* ── REGISTRO ── */}
          <p className="lu-footer-text">
            {t('profile.login.newHere')}
            <button className="lu-footer-link" type="button" onClick={() => setModalUserRegister(true)}>
              {t('profile.login.createAccount')}
            </button>
          </p>

        </div>
      </div>

      {/* ── COMPONENTES ORIGINALES ── */}

      <EditUserInfo
        modalUserUpdate={showModalForgotPassword}
        setModalUserUpdate={setShowModalForgotPassword}
        recoveryPasss={true}
      />
      <RegisterUser
        modalUserRegister={modalUserRegister}
        setModalUserRegister={setModalUserRegister}
        setNickNameLogin={setNickName}
        setPasswordLogin={setPassword}
        loginUser={loginUser}
      />
    </>
  );
};

export default LoginUser;
